import { useCurrentDealTradeIns, type TradeInVehicle } from '@makemydeal/dr-activities-customer-vehicles';
import { MAX_TRADE_INS_FOR_MODAL } from '../constants';

export const useTradeInsForModal = (): TradeInVehicle[] => {
    const tradeIns = useCurrentDealTradeIns();

    // useCurrentDealTradeIns returns VIN-deduplicated trade-ins ordered most-recent-first, so
    // taking the first MAX_TRADE_INS_FOR_MODAL gives the latest trade-ins.
    return tradeIns.slice(0, MAX_TRADE_INS_FOR_MODAL).map((t) => ({
        vin: t.vin ?? undefined,
        year: t.year != null ? String(t.year) : undefined,
        make: t.make ?? undefined,
        model: t.model ?? undefined,
        trim: t.trim ?? undefined
    }));
};
